/*
Code for the Resources Page
*/

import { Footer } from "./Footer";
import Accordion from "react-bootstrap/Accordion";
import Button from "react-bootstrap/Button";
import { Header } from "./Header";
import background from "./images/sunset_bright.JPG";

function Resources() {
  return (
    <div>
      <Header />
      <div className="page-header">
        <img className="header-img" src={background} alt="background" />
        <h1 className="header-img-caption"> 5C Resources</h1>
        <p className="header-img-text">
          Clubs, websites, and resources for students interested in DS, CS, and
          other technical fields
        </p>
      </div>
      <div>
        <div className="space1" />
        <h2>Clubs</h2>
        <Accordion className="resource_accordion">
          <Accordion.Item eventKey="0" className="resource_accordion">
            <Accordion.Header className="resource_accordion">
              Scripps Code
            </Accordion.Header>
            <Accordion.Body>
              <p>
                {" "}
                Offers academic and social events like recruiting events, CS
                socials, and networking opportunities with peers. Join for
                support, and the chance to make lifelong friends in your field
                while navigating CS programs at Scripps and the Claremont
                Colleges.
              </p>
              <Button
                className="resource-button"
                href="https://engage.claremont.edu/engage/organization/scrippscode"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1" className="resource_accordion">
            <Accordion.Header className="resource_accordion">
              Women of the Association of Computing Machinery (W-ACM)
            </Accordion.Header>
            <Accordion.Body>
              <p>
                {" "}
                A 5C organization whose mission is to empower women to engage
                with technology and to promote the participation of women in
                computing. Throughout the year workshops dedicated to teaching
                practical skills, host regular social gatherings for students to
                meet and discuss their projects and interests are held. The
                organization works with other 5C CS departments to help sponsor
                speakers, talks, and trips to computing-related events and
                conferences.
              </p>
              <Button
                className="resource-button"
                href="https://engage.claremont.edu/engage/organization/5c-wacm"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2" className="resource_accordion">
            <Accordion.Header className="resource_accordion">
              Association of Women in Math (AWM)
            </Accordion.Header>
            <Accordion.Body>
              <p>
                {" "}
                The goal of Association for Women in Mathematics is to connect
                students with math-related support and experiences, build a
                network of mathematicians on campus, and engage with the local
                community.
              </p>
              <Button
                className="resource-button"
                href="https://engage.claremont.edu/engage/organization/awm_math"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3" className="resource_accordion">
            <Accordion.Header className="resource_accordion">
              P-ai
            </Accordion.Header>
            <Accordion.Body>
              <p>
                A Technical Project Incubator at the Claremont Colleges
                exploring applied computer science & AI/ML.
              </p>
              <Button
                className="resource-button"
                href="https://www.p-ai.org/"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="4" className="resource_accordion">
            <Accordion.Header className="resource_accordion">
              Graphite Consulting Group
            </Accordion.Header>
            <Accordion.Body>
              <p>
                A student-run consulting group at the Claremont Colleges that
                provides consulting services for start-ups, non-profits,
                institutions and businesses that are driven by innovation,
                entrepreneurship, and transformation.
              </p>
              <Button
                className="resource-button"
                href="https://www.thegraphitegroup.com/"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5" className="resource_accordion">
            <Accordion.Header className="resource_accordion">
              Pomona Consulting Group (PCG)
            </Accordion.Header>
            <Accordion.Body>
              <p>
                Pomona Consulting Group (PCG) is a student organization at the
                Claremont Colleges focused on bringing real value to a variety
                of businesses. We support pre-professional development for
                students through hands-on project experience, networking events,
                and workshops. Former clients have ranged from startups to
                community groups and Fortune 500 organizations.
              </p>
              <Button
                className="resource-button"
                href="https://www.pomonaconsulting.org/"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="6" className="resource_accordion">
            <Accordion.Header className="resource_accordion">
              Product Space
            </Accordion.Header>
            <Accordion.Body>
              <p>
                Product Space is a multi-school learning resource for students
                interested in tech from the 5 Claremont Colleges.
              </p>
              <Button
                className="resource-button"
                href="https://productspaceclaremont.webflow.io/"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="7" className="resource_accordion">
            <Accordion.Header className="resource_accordion">
              5C Hack
            </Accordion.Header>
            <Accordion.Body>
              <p>
                {" "}
                5C Hack aims to connect students across the 5Cs who are
                interested in computers and recreational programming, design,
                and software development projects. In addition, a 5C Hackathon
                is hosted once every year in an effort to encourage students to
                build their technical skills outside of the classroom.
              </p>
              <Button
                className="resource-button"
                href="https://engage.claremont.edu/engage/organization/5chack"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <div className="space1" />

        <h2>Hackathons/Datathons</h2>
        <Accordion className="resource_accordion">
          <Accordion.Item eventKey="0" className="resource_accordion_header">
            <Accordion.Header className="resource_accordion">
              5C Hackathon: Datathon and Hackathon
            </Accordion.Header>
            <Accordion.Body>
              <p>
                The 5c Hackathon is open to all 5c students with all levels of
                coding experience.
              </p>
              <Button
                className="resource-button"
                href="https://5c-hackathon-2024.devpost.com/"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1" className="resource_accordion_header">
            <Accordion.Header className="resource_accordion">
              Hacktech - Caltech
            </Accordion.Header>
            <Accordion.Body>
              <p>Hacktech is an in-person hackathon at Caltech.</p>
              <Button
                className="resource-button"
                href="https://hack.caltech.edu/"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2" className="resource_accordion">
            <Accordion.Header className="resource_accordion">
              CSAS Data Challenge
            </Accordion.Header>
            <Accordion.Body>
              <p>
                CSAS offers a sports data-related challenge to data science
                students.
              </p>
              <Button
                className="resource-button"
                href="https://statds.org/events/csas2025/challenge.html"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3" className="resource_accordion">
            <Accordion.Header className="resource_accordion">
              WIDS Datathon
            </Accordion.Header>
            <Accordion.Body>
              <p>
                At the WIDS Datathon, participants use data analysis to solve
                real-world societal issues.
              </p>
              <Button
                className="resource-button"
                href="https://www.widsworldwide.org/learn/datathon/"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <div className="space1" />

        <h2 className="resource-header">Workshops</h2>
        <Accordion className="resource_accordion">
          <Accordion.Item eventKey="0" className="resource_accordion_header">
            <Accordion.Header className="resource_accordion">
              Machine learning workshop series offered at Mudd in the spring
            </Accordion.Header>
            <Accordion.Body>
              <p>
                For those wanting to learn more about applying machine learning
                to data analysis, Mudd offers a workshop every spring.
              </p>
              <Button
                className="resource-button"
                href="https://github.com/AashitaK/A-Hands-On-Workshop-In-Machine-Learning-Spring-2024?tab=readme-ov-file"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <div className="space1" />

        <h2>TCCS Resources</h2>
        <Accordion className="resource_accordion">
          <Accordion.Item eventKey="0" className="resource_accordion_header">
            <Accordion.Header className="resource_accordion">
              Data Science Hub at Honnold Mudd Library
            </Accordion.Header>
            <Accordion.Body>
              <p>
                This calendar is a central site for information about data
                science events and workshops across the 7Cs.
              </p>
              <Button
                className="resource-button"
                href="https://datascience.library.claremont.edu/"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1" className="resource_accordion_header">
            <Accordion.Header className="resource_accordion">
              Drop-In Tutoring at the Scripps Mathspot
            </Accordion.Header>
            <Accordion.Body>
              <p>
                A program that provides drop-in tutoring for Scripps College
                math classes throughout the semester.
              </p>
              <Button
                className="resource-button"
                href="https://www.scrippscollege.edu/academics/tutoring-programs-writing-center"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <div className="space1" />

        <h2>Mailing Lists</h2>
        <Accordion className="resource_accordion">
          <Accordion.Item eventKey="0" className="resource_accordion_header">
            <Accordion.Header className="resource_accordion">
              Pomona Math
            </Accordion.Header>
            <Accordion.Body>
              <p>
                Pomona's Math department has a email ListServ with messages
                related to math and data science-related events (
                <a
                  className="faculty-link"
                  href="mailto:MATH-STUDENTS@LISTSERV.POMONA.EDU"
                >
                  MATH-STUDENTS@LISTSERV.POMONA.EDU
                </a>
                )
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1" className="resource_accordion_header">
            <Accordion.Header className="resource_accordion">
              Pomona Computer Science
            </Accordion.Header>
            <Accordion.Body>
              <p>
                Pomona's Computer Science department also sends messages with CS
                and data science-related career, extracurricular, and academic
                opportunities (
                <a
                  className="faculty-link"
                  href="mailto:CS-ALL@LISTSERV.POMONA.EDU"
                >
                  CS-ALL@LISTSERV.POMONA.EDU
                </a>
                )
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2" className="resource_accordion_header">
            <Accordion.Header className="resource_accordion">
              Harvey Mudd Math
            </Accordion.Header>
            <Accordion.Body>
              <p>
                Harvey Mudd's math department also sends messages with math
                related career, extracurricular, and academic opportunities (
                <a
                  className="faculty-link"
                  href="mailto:math-announce-l@g.hmc.edu"
                >
                  math-announce-l@g.hmc.edu
                </a>
                )
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3" className="resource_accordion_header">
            <Accordion.Header className="resource_accordion">
              Claremont Math
            </Accordion.Header>
            <Accordion.Body>
              <p>
                The Claremont Consortium has a collective ListServ, which may be
                useful for intercollege studies (
                <a
                  className="faculty-link"
                  href="mailto:claremont-math@lists.claremont.edu"
                >
                  claremont-math@lists.claremont.edu
                </a>
                )
              </p>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <div className="space1" />

        <h2>Books</h2>
        <Accordion className="resource_accordion">
          <Accordion.Item eventKey="0" className="resource_accordion_header">
            <Accordion.Header className="resource_accordion">
              Weapons of Math Destruction by Cathy O'Neil (Novel)
            </Accordion.Header>
            <Accordion.Body>
              <p>
                This book discusses the impact of data science on society and
                highlights the need for ethical data usage.
              </p>
              <Button
                className="resource-button"
                href="https://www.penguinrandomhouse.com/books/241363/weapons-of-math-destruction-by-cathy-oneil/"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1" className="resource_accordion_header">
            <Accordion.Header className="resource_accordion">
              Learning from Data by Yaser Abu-Mostafa (Textbook)
            </Accordion.Header>
            <Accordion.Body>
              <p>
                Learning from Data provides a clear introduction to machine
                learning and data analysis for new learners.
              </p>
              <Button
                className="resource-button"
                href="https://www.amazon.com/Learning-Data-Yaser-S-Abu-Mostafa/dp/1600490069"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <div className="space1" />

        <h2>Off Campus DS options</h2>
        <Accordion className="resource_accordion">
          <Accordion.Item eventKey="0" className="resource_accordion">
            <Accordion.Header className="resource_accordion">
              Data Science Major: CMC
            </Accordion.Header>
            <Accordion.Body>
              <p>
                The major in data science requires a minimum of 2 prerequisites
                and 12 courses. Students will learn relevant programming
                abilities, statistical analysis, communication skills, and tools
                for data science.
              </p>
              <Button
                className="resource-button"
                href="https://catalog.claremontmckenna.edu/preview_entity.php?catoid=38&ent_oid=1591&returnto=7766"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1" className="resource_accordion">
            <Accordion.Header className="resource_accordion">
              Data Science Minor: Pitzer
            </Accordion.Header>
            <Accordion.Body>
              <strong>
                Note: Scripps students intending to minor in DS must do so at
                Scripps
              </strong>
              <p>
                This programs blends computer science, statistics, and data
                science with ethics and social justice themes. Electives may
                include an exploration of GIS, Bioinformatics and Machine
                Learning.
              </p>
              <Button
                className="resource-button"
                href="https://catalog.pitzer.edu/preview_program.php?catoid=28&poid=3562&returnto=2027"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2" className="resource_accordion">
            <Accordion.Header className="resource_accordion">
              Data Science Minor: Pomona
            </Accordion.Header>
            <Accordion.Body>
              <strong>
                Note: Scripps students intending to minor in DS must do so at
                Scripps{" "}
              </strong>
              <p>
                The data science minor at Pomona is open to students majoring in
                any discipline who wish to develop skills in using and analyzing
                data.
              </p>
              <Button
                className="resource-button"
                href="https://www.pomona.edu/academics/majors/data-science"
                target="_blank"
              >
                Learn more
              </Button>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <div className="space1"></div>
      <Footer />
    </div>
  );
}
export default Resources;
